<template>
  <div>
    <div class="row">
      <div class="col">
        <router-link to="/" class="link-back">
          <MaterialSvg
            class="icon-white"
            name="keyboard_backspace"
            :width="24"
          />
          {{ $t('detail.back') }}
        </router-link>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col">
        <MaterialSvg class="icon-cyaan" name="check_cirle" :width="80" />
        <h1 class="display-4 text-center">{{ $t('shop.thank-you') }}</h1>
        <p class="lead text-center">{{ $t('shop.request-received') }}</p>
      </div>
    </div>
    <div class="card my-3">
      <div class="card-body">
        <h4 class="card-title">{{ $t('shop.request-details') }}</h4>
        <p class="card-text">{{ $t('shop.request-contact') }}</p>
        <hr class="my-4" />
        <div
          v-for="product in products"
          :key="product.key"
          class="product d-flex align-items-center mb-3"
        >
          <img :src="product.image.format.small.url" />
          <div class="ml-3">
            <span>{{ amount }}x</span> {{ product.title }}
          </div>
        </div>
      </div>
      <div class="card-footer text-center text-muted">
        {{ $t('shop.request-questions') }}
        <router-link class="contact-link" to="/contact"> contact </router-link>
        {{ $t('shop.request-us') }}
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OrderComplete',
  props: {
    ids: {
      type: String,
      required: false,
    },
  },
  computed: {
    amount() {
      let amount = 1;
      if (this.products.length === 1) {
        amount = 2;
      }
      return amount;
    },
    scentIds() {
      return this.ids.split(',').map(Number);
    },
    products() {
      return this.getScentsById(this.scentIds);
    },
    ...mapGetters({
      getScentsById: ['scents/getScentsById'],
    }),
  },
};
</script>

<style scoped lang="scss">
h1 {
  margin-top: 0;
  margin-bottom: 0;
}
.contact-link {
  color: inherit;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    opacity: 0.9;
  }
}
.icon-cyaan {
  display: block;
  margin: 0 auto;
  fill: $primary-color;
}
.product {
  img {
    height: 75px;
    width: 75px;
    border-radius: $border-radius;
    object-fit: cover;
  }
}
</style>
